import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { PushMessage } from "../entity";
import { PushMessageState } from "../state";

const initialState: PushMessageState = {
  pushMessages: [],
  page: 1,
  pushMessage: null!,
  title: "",
  body: "",
  isSent: false,
  immediate: false,
  sendDate: "",
  sendTime: "",
  created: "",
  updated: "",
  pageCount: null!,
  errorMessage: null,
  pushMessageActionStart: false,
  searchText: "",
  selectedId: null!,
};

export const pushMessageSlice = createSlice({
  name: "pushMessage",
  initialState,
  reducers: {
    setPushMessages: (
      state,
      action: PayloadAction<{ pushMessages: PushMessage[]; pageCount: number }>,
    ) => {
      state.pushMessages = action.payload.pushMessages;
      state.pageCount = action.payload.pageCount;
      state.pushMessageActionStart = false;
    },
    addPushMessageToPushMessages: (
      state,
      action: PayloadAction<{ pushMessage: PushMessage }>,
    ) => {
      state.pushMessages = [...state.pushMessages, action.payload.pushMessage];
      state.errorMessage = null;
      state.pushMessageActionStart = false;
    },
    setSearchText: (state, action: PayloadAction<string>) => {
      state.searchText = action.payload;
      state.page = 1;
    },
    setPushMessagePage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setPushMessagePushMessage: (state, action: PayloadAction<PushMessage>) => {
      state.pushMessage = action.payload;
    },
    setPushMessageBody: (state, action: PayloadAction<string>) => {
      state.body = action.payload;
    },
    setPushMessageTitle: (state, action: PayloadAction<string>) => {
      state.title = action.payload;
    },
    setPushMessageIsSent: (state, action: PayloadAction<boolean>) => {
      state.isSent = action.payload;
    },
    setPushMessageImmediate: (state, action: PayloadAction<boolean>) => {
      state.immediate = action.payload;
    },
    setPushMessageSendDate: (state, action: PayloadAction<string>) => {
      state.sendDate = action.payload;
    },
    setPushMessageSendTime: (state, action: PayloadAction<string>) => {
      state.sendTime = action.payload;
    },
    setPushMessageCreated: (state, action: PayloadAction<string>) => {
      state.created = action.payload;
    },
    setPushMessageUpdated: (state, action: PayloadAction<string>) => {
      state.updated = action.payload;
    },
    setPushMessageSearchText: (state, action: PayloadAction<string>) => {
      state.searchText = action.payload;
    },
    setPushMessageErrorMessage: (
      state,
      action: PayloadAction<string | null>,
    ) => {
      state.errorMessage = action.payload;
      state.pushMessageActionStart = false;
    },
    resetPushMessage: (state) => {
      state.page = 1;
      state.pushMessage = null!;
      state.title = "";
      state.body = "";
      state.isSent = false;
      state.immediate = false;
      state.sendDate = "";
      state.created = "";
      state.updated = "";
      state.errorMessage = null;
      state.pushMessageActionStart = false;
      state.searchText = "";
      state.selectedId = null!;
    },
    setPushMessageActionStart: (state, action: PayloadAction<boolean>) => {
      state.pushMessageActionStart = action.payload;
    },

    setPushMessageSelectedId: (state, action: PayloadAction<number>) => {
      state.selectedId = action.payload;
    },

    removePushMessageFromPushMessages: (
      state,
      action: PayloadAction<number>,
    ) => {
      if (state.pushMessages.length % 10 === 1) {
        state.page -= 1;
        state.pageCount -= 1;
      }
      state.pushMessages = state.pushMessages.filter(
        (pushMessage) => pushMessage.id !== action.payload,
      );
      state.pushMessageActionStart = false;
    },

    setPushMessage: (
      state,
      action: PayloadAction<{ pushMessage: PushMessage }>,
    ) => {
      state.pushMessage = action.payload.pushMessage;
      state.title = action.payload.pushMessage?.title;
      state.body = action.payload.pushMessage?.body;
      state.isSent = action.payload.pushMessage?.isSent;
      state.immediate = action.payload.pushMessage?.immediate;
      state.sendDate = action.payload.pushMessage?.sendDate;
      state.created = action.payload.pushMessage?.created;
      state.updated = action.payload.pushMessage?.updated;
      state.pushMessageActionStart = false;
    },
  },
});

export const {
  setPushMessages,
  setPushMessagePage,
  setPushMessagePushMessage,
  setPushMessageBody,
  setPushMessageTitle,
  setPushMessageIsSent,
  setPushMessageImmediate,
  setPushMessageSendDate,
  setPushMessageSendTime,
  setPushMessageCreated,
  setPushMessageUpdated,
  setPushMessageSearchText,
  resetPushMessage,
  setPushMessageErrorMessage,
  setPushMessageActionStart,
  removePushMessageFromPushMessages,
  addPushMessageToPushMessages,
  setSearchText,
  setPushMessage,
  setPushMessageSelectedId
} = pushMessageSlice.actions;
